import { render, staticRenderFns } from "./MembershipsPage.vue?vue&type=template&id=62285194&scoped=true&"
import script from "./MembershipsPage.vue?vue&type=script&lang=js&"
export * from "./MembershipsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62285194",
  null
  
)

export default component.exports